import {
  PasswordResetRequest,
  PasswordResetResponse,
} from "./passwordReset-models";
import { SIMPLE_PAYMENTS_SERVICE_GW_PREFIX } from "../constants";
import { createApiClientWithArgs } from "cy-fetch/lib/client";

export * from "./passwordReset-models";

export const passwordResetUrl = `${SIMPLE_PAYMENTS_SERVICE_GW_PREFIX}/api/v1/simple_payments/customers/reset_password`;

export const passwordResetRequestClient = createApiClientWithArgs({
  zod: PasswordResetResponse,
  argsFn: (args: PasswordResetRequest) => {
    return {
      url: passwordResetUrl,
      options: {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(args),
      },
    };
  },
});
